import {Routes} from 'react-router-dom';
import {getRoutes} from "../../helpers/getRoutes";
import {authenticationRoutes} from "../../helpers/applicationRoutes/authenticationRoutes";

const Main = () => {
    return (
        <div className="dashboard-wrapper">
            <Routes>
                {getRoutes(authenticationRoutes)}
            </Routes>
        </div>
    );
}
export default Main;
